import axios from 'axios'

export default class EvaluationResource {
  groups (page = 1, perPage = 20, filters = { }, sort = { }, toExport = false) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    if (toExport) {
      return axios.get(`/api/evaluations?export=1&page=${page}&per_page=${perPage}&${filterString}&${sortString}`, {
        responseType: 'blob'
      })
    }

    return axios.get(`/api/evaluations?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  evaluationWeeks (group) {
    return axios.get(`/api/evaluations/${group}`)
  }

  instruction (status) {
    return axios.get(`/api/evaluations/instructions?type=${status}`)
  }

  openRequestReasons () {
    return axios.get('/api/evaluations/delayed-grades/reasons')
  }

  openRequestStudents (group, week) {
    return axios.get(`/api/evaluations/delayed-grades/students/${group}/${week}`)
  }

  sendOpenRequest (group, week, reasonId, studentId) {
    return axios.post('/api/evaluations/delayed-grades', {
      group: group,
      grade_id: week,
      reason_id: reasonId,
      student_id: studentId
    })
  }

  evaluationDetails (group, week,componentRequestID) {
    let weekParam = ''
    if (week) weekParam = `/${week}`

    return axios.get(`/api/evaluations/${group}/${componentRequestID}/details${weekParam}`)
  }
  downloadPresentationFile (fileFullPath) {
    

    return axios.post(`/api/evaluations/downloadPresentationFile`,{fileFullPath},{responseType:'blob'})
  }

 
  getPresentationFileLink(fileFullPath){

    return axios.post(`/api/evaluations/getPresentationFileLink`,{fileFullPath})

  }


  saveEvaluation (group, studentId, rateComponentId, point, week = null) {
    let weekParam = ''
    if (week) weekParam = `/${week}`

    return axios.post(`/api/evaluations${weekParam}`, {
      group: group,
      student_id: studentId,
      rate_component_id: rateComponentId,
      point: point
    })
  }

  presentations (group) {
    return axios.get(`/api/evaluations/${group}/presentations`)
  }

  detailedInformation (group) {
    return axios.get(`/api/evaluations/${group}/info`)
  }

  templates (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/evaluations/templates?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  quizCriterias () {
    return axios.get('/api/evaluations/templates/quiz-criterias')
  }
}
